/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from "react";
import CommonContext from "../../hooks/commonContext";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { Container, Button } from "@material-ui/core";
import PageTitle from "../../components/pageTitle/PageTitle";
import StepProfile from "./steps/Profile";
import EmployeeStepsContext from "../../hooks/EmployeeStepsContext";
import validator from "validator";
import { validateUniqueUser } from "../../services/apiservices/users";
import { Edit, KeyRound, RotateCcw, Trash2 } from "lucide-react";
import AssignGroup from "./steps/AssignGroup";
import { generateP, packageAccess } from "../../services/helpers";
import confirm from "../../components/DialogComponent/confirm";
import { forgotPasswordUser, ResendAppLink, ResendCMSLink } from "../../services/firebase";
import {
  addEmployee,
  updateEmployee,
  getEmployee,
  deleteEmployee,
  updateUserPassword,
  getCompanyEmployees,
} from "../../services/apiservices/employee";
import AuthContext from "../../hooks/authContext";
import styles from "./employee.module.scss";
import { useMediaQuery } from "@mui/material";
import { useToast } from "../../hooks/useToast";

const CreateEmployee = (props) => {
  const commonContext = useContext(CommonContext);
  let history = useNavigate();
  const { employeeId } = useParams();
  const stepsContext = useContext(EmployeeStepsContext);
  const [settingsData, setSettingsData] = useState();
  const [clientsList, setClientsList] = useState([]);
  const [allgroups, setAllGroups] = React.useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [editData, setEditData] = useState({});
  const [companyData, setCompanyData] = useState();
  const [stepFormValues, setStepFormValue] = useState({});
  const [stepFormErrors, setStepFormError] = useState({});
  const [companyEmployee, setCompanyEmployee] = useState(false);
  const [finalLoading, setFinalLoading] = useState(false);
  const { stepsArray } = stepsContext;
  const [displayStep, setDisplayStep] = useState(1);
  const auth = useContext(AuthContext);
  const { toast } = useToast();
  const isMobile = useMediaQuery("(max-width:767px)");
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;
  const isEdit = typeof employeeId !== "undefined" && employeeId !== "";
  const getEmployeeDetails = (employeeId) => {
    if (typeof employeeId !== "undefined" && employeeId !== "") {
      commonContext?.setLoader(true);
      getEmployee(
        employeeId,
        (res) => {
          if (res?.status === true) {
            setEditData({ ...res?.data, employeeId: employeeId });
            setStepFormValue({ ...res?.data, employeeId: employeeId });
          }
          commonContext?.setLoader(false);
        },
        (resError) => {
          if (resError?.error === "Employee not found") {
            history("/peoples/manageEmp");
          }
          commonContext?.setLoader(false);
        }
      );
    } else {
      setStepFormValue({});
      commonContext?.setLoader(false);
    }
  };
  useEffect(() => {
    getEmployeeDetails(employeeId);
  }, [employeeId]);

  useEffect(() => {
     const pkgId = auth?.userProfile?.prdId;
    const allowedPermissions = packageAccess(pkgId);

  const UsersLimits =
    allowedPermissions?.userLimit + auth?.userProfile?.additionalQuantity;

  const userLimit =
    pkgId === "prod_RvDCcqf57eCBxS"
      ? auth?.userProfile?.quantity
      : UsersLimits;

  const checkEmployeeLimit = (activeCount) => {
    setCompanyEmployee(activeCount >= userLimit);
  };

  if (!pkgId) return;

  if (auth?.userProfile?.role === "superUser" && stepFormValues?.companyId) {
    getCompanyEmployees(stepFormValues?.companyId, (res) => {
      if (res?.data) {
        const active = res?.data?.filter((item) => item?.status === true);
        checkEmployeeLimit(active?.length);
      } else {
        setCompanyEmployee(false);
      }
    });
  } else if (auth?.userProfile?.role !== "superUser") {
    const activeCount = auth?.userProfile?.employeesLength || 0;
    checkEmployeeLimit(activeCount);
  }
}, [
    auth?.userProfile?.prdId,
    auth?.userProfile?.role,
    auth?.userProfile?.quantity,
    auth?.userProfile?.employeesLength,
    stepFormValues?.companyId,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const companyUserData = await new Promise((resolve) => {
          getEmployee(
            companyId,
            (res) => {
              const companyResult = res?.data;
              resolve(companyResult || []);
            },
            (err) => {
              console.error("Error fetching groups:", err);
              resolve([]);
            }
          );
        });

        setCompanyData(companyUserData);
      } catch (error) {
        console.error("Unexpected error:", error);
        setCompanyData([]);
      }
    };

    if (companyId) fetchData();
  }, [companyId]);

  // useEffect(() => {
  //   const fetchSettings = async () => {
  //     await getSettings("appointment_settings", (res) => {
  //       if (res?.data) {
  //         const filteredData = res?.data?.filter(
  //           (item) => item.companyId === companyId && !item.deleted
  //         );
  //         setSettingsData(filteredData);
  //       } else {
  //         setSettingsData();
  //       }
  //     });
  //   };
  //   fetchSettings();
  // }, []);

  const goPrev = () => {
    let newStep = currentStep > 1 ? currentStep - 1 : 1;
    setCurrentStep(newStep);
  };

  const goNext = () => {
    let newStep =
      currentStep < stepsArray?.length ? currentStep + 1 : currentStep;
    setCurrentStep(newStep);
  };

const handleInputChange = (event) => {
  const {
    target: { name, value },
  } = event;

  let finalValue = name === "email" ? value.trim() : value;

  if (name === "email") {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const invalidSequenceRegex = /[\/]{1}|\.{2,}|\/\.|\.\/|[^a-zA-Z0-9._%+-@]/;

    if (!emailRegex.test(finalValue)) {
      setStepFormError({
        ...stepFormErrors,
        [name]: "Please enter a valid email address.",
      });
    } else if (invalidSequenceRegex.test(finalValue)) {
      setStepFormError({
        ...stepFormErrors,
        [name]: "Email contains invalid characters.",
      });
    } else {
      setStepFormError({
        ...stepFormErrors,
        [name]: "",
      });
    }
  } else {
    setStepFormError({
      ...stepFormErrors,
      [name]: "",
    });
  }

  if (name === "manualAcuityId") {
    setStepFormValue({
      ...stepFormValues,
      [name]: finalValue,
      acuityId: finalValue,
    });
  } else {
    setStepFormValue({
      ...stepFormValues,
      [name]: finalValue,
    });
  }
};


  const handleSingleSelectChange = (name) => (value) => {
  setStepFormValue((prev) => ({
    ...prev,
    [name]: value,
  }));

  setStepFormError((prev) => ({
    ...prev,
    [name]: "",
  }));
};

  const getStepContent = (step) => {
    switch (step) {
      case 1:
      // return (
      //   <StepProfile
      //     handleInputChange={handleInputChange}
      //     validateAndGoNext={validateAndGoNext}
      //   />
      // );
      case 2:
      // return (
      //   <AssignGroup
      //     handleInputChange={handleInputChange}
      //     validateAndGoNext={validateAndGoNext}
      //   />
      // );
      case 3:
      // return (
      //   <ClientTeam
      //     handleInputChange={handleInputChange}
      //     validateAndGoNext={validateAndGoNext}
      //   />
      // );
      case 4:
      // if (settingsData?.[0]?.schedulingSystem !== "proteams") {
      //   return (
      //     <AcuityProfile
      //       handleInputChange={handleInputChange}
      //       validateAndGoNext={validateAndGoNext}
      //       settingsData={settingsData}
      //     />
      //   );
      // }
      default:
        return <></>;
    }
  };

  const onCancelAll = () => {
    setStepFormValue({});
    setStepFormError({});
    setDisplayStep(1);
    const isEdit = typeof employeeId !== "undefined" && employeeId !== "";
    isEdit === true && history("/peoples/manageEmp");
  };

  const checkUniqUserValidation = async () => {
    setFinalLoading(true);
    let isUniqueValid = true;
    const { email, phoneNumber, userId } = stepFormValues;
    await validateUniqueUser(
      { email: email, mobile: phoneNumber, userId: userId },
      (res) => {
        let dataobj = res?.data;
        if (
          dataobj &&
          Object.keys(dataobj).length === 0 &&
          dataobj.constructor === Object
        ) {
          isUniqueValid = true;
        } else {
          isUniqueValid = dataobj;
        }
        setFinalLoading(false);
      },
      () => {
        isUniqueValid = { form: "Something went wrong" };
        setFinalLoading(false);
      }
    );
    return await isUniqueValid;
  };

  const registerEmployee = async () => {
    setFinalLoading(true);
    const {
      firstName,
      lastName,
      phoneNumber,
      email,
      clients,
      employeerole,
      group,
      acuityId,
      isManager,
      timeZone,
      companyId,
    } = stepFormValues;

    const determinedCompanyId =
      auth.userProfile.role === "superUser"
        ? companyId
        : auth.userProfile.role === "companyUser"
        ? auth.userProfile.id
        : auth.userProfile.companyId;

    const password = generateP();
    var newUser = {
      firstName: firstName,
      lastName: lastName,
      phoneNumber: phoneNumber,
      email: email,
      username: email,
      timeZone: timeZone,
      companyId: determinedCompanyId,
      isManager: isManager ? isManager : false,
      role: "Employee",
      userId: "1",
      password: password,
      confirmPassword: password,
      // clients: clients ? clients : [],
      // employeerole: employeerole ? employeerole : "Guest",
      // group: group ? group : [],
      // acuityId: acuityId ? String(acuityId) : "",
    };

    const contactName = `${auth?.userProfile?.firstName} ${auth?.userProfile?.lastName}`;
    const companyName = `${companyData?.companyName}`;
    try {
     const result = await addEmployee(newUser, contactName, companyName);
        if (result?.data?.status === true) {
          auth.setNewEmpId(result?.data?.id);
          setDisplayStep(displayStep + 1);
          setFinalLoading(false);
          // confirm("Employee is Created Successfully", { cancel: false }).then(
          //   () => {
          //     history("/peoples/manageEmp");
          //   }
          // );
          // onCancelAll();
        } else {
          setFinalLoading(false);
        }
      } catch (error) {
        const errMessage =
          error?.response?.data?.error?.message ||
          error?.response?.data?.message ||
          error?.message ||
          "Unexpected error occurred.";
        setStepFormError({ finalerror: errMessage });
    } finally {
      setFinalLoading(false);
    }
  };

  const runupdateEmployee = async ({ finalStep = false } = {}) => {
    const id = editData?.userId || auth.newEmpId;
    const newId = employeeId || auth.newEmpId;
    setFinalLoading(true);

    try {
      // const oldGroups = Array.isArray(editData?.group) ? editData?.group : [];
      // const newGroups = Array.isArray(stepFormValues?.group) ? stepFormValues?.group : [];

      // let groupOps = [];
      // if (stepFormValues?.employeerole === "Client Team") {
      //   const groupsChanged = JSON.stringify(oldGroups?.sort()) !== JSON.stringify(newGroups?.sort());
      //   if (newGroups?.length > 0 && groupsChanged) {
      //     const toRemove = oldGroups?.filter((g) => !newGroups?.includes(g));
      //     const toAdd = newGroups?.filter((g) => !oldGroups?.includes(g));
      //     groupOps = [
      //       ...toRemove?.map((g) => updateEmployeetoGroup("remove", g, newId)),
      //       ...toAdd?.map((g) => updateEmployeetoGroup("add", g, newId)),
      //     ];
      //   }
      // }

      await updateEmployee(
        newId,
        stepFormValues,
        editData,
        async (empRes) => {
          if (!empRes?.status) {
            setFinalLoading(false);
            return;
          }

          // if (groupOps?.length > 0) {
          //   Promise.allSettled(groupOps)?.then((results) => {
          //     console.log("Group update results:", results);
          //   }).catch((err) => {
          //     console.error("Group update error:", err);
          //   });
          // }

          // if (displayStep === 2 && stepFormValues?.employeerole !== "Client Team") {
          //   setFinalLoading(false);
          //   return history("/peoples/manageEmp");
          // }

          if (displayStep === 2) {
            await confirm(employeeId ? "Employee is Updated Successfully" : "Employee is Created Successfully", { cancel: false });
            setFinalLoading(false);
            auth?.setNewEmpId();
            toast({ title: "Success", description: employeeId ? "Employee Updated Successfully" : "Employee is Created Successfully" });
            onCancelAll();
            return history("/peoples/manageEmp");
          }

          getEmployeeDetails(employeeId);
          setDisplayStep(displayStep + 1);
          setFinalLoading(false);
          auth?.setNewEmpId();
        },
        (empErrorRes) => {
          const errordata = empErrorRes?.response?.data || {};
          const error = errordata.error?.message || errordata.message || "Unknown error";
          setStepFormError({ finalerror: error });
          setFinalLoading(false);
        }
      );
    } catch (error) {
      console.error("Error during employee update:", error);
      setStepFormError({ finalerror: error.message || "Something went wrong." });
      setFinalLoading(false);
    }
  };

  const rundeleteEmployee = async () => {
    commonContext?.setLoader(true);
    deleteEmployee(
      employeeId,
      stepFormValues,
      (empRes) => {
        if (empRes?.status === true) {
          commonContext?.setLoader(false);
          history("/peoples/manageEmp");
          window.location.reload();
          toast({ title: "Success", description: "Employee Deleted Successfully" });
          onCancelAll();
        } else {
          commonContext?.setLoader(false);
        }
      },
      (empErrorRes) => {
        commonContext?.setLoader(false);
        let errordata = empErrorRes?.response?.data;
        let error = errordata?.error
          ? errordata?.error?.message
          : errordata?.message
          ? errordata?.message
          : "";
        setStepFormError({ finalerror: error });
      }
    );
  };

  const ResetPasswordLink = async () => {
    commonContext?.setLoader(true);
    const { email } = stepFormValues;
    await forgotPasswordUser(
      email,
      () => {
        commonContext?.setLoader(false);
        toast({ title: "Success", description: "Reset Password Link sent to User's Email..." });
      },
      (error) => {
        commonContext?.setLoader(false);
        console.error("Error resetting password:", error);
        toast({
          title: "Error",
          description: error?.message || "An error occurred. Please try again.",
          variant: "destructive",
        });
      }
    );
  };

  const ResendinvitaLink = async () => {
    commonContext?.setLoader(true);
    const { firstName, email, phoneNumber } = stepFormValues;
    const password = generateP();
    try {
      await updateUserPassword(editData?.userId, {
        password: password,
        email: email,
      });

      const contactName = `${auth?.userProfile?.firstName} ${auth?.userProfile?.lastName}`;
      const companyName = `${companyData?.companyName}`;
      const role = editData?.employeerole;

      if(editData?.employeerole === "Client Team"){
        Promise.allSettled([
          ResendAppLink(email, phoneNumber, firstName, password, contactName, companyName),
        ]).then((results) => {
          console.log("Background invite results:", results);
        });
      } else {
        Promise.allSettled([
          ResendCMSLink(email, phoneNumber, firstName, password, role),
        ]).then((results) => {
          console.log("Background invite results:", results);
        });
      }

      commonContext?.setLoader(false);
      // alert("Resend Invitation sent to Employee");
      toast({ title: "Success", description: "Resend Invitation sent to Employee" });
    } catch (error) {
      commonContext?.setLoader(false);
      console.error("Error sending invitation link:", error);
      // alert("An error occurred. Please try again.");
      toast({ title: "Error", description: error?.message || "An error occurred. Please try again.", variant: "destructive" });
    }
  };

  const validateAndGoNext = async () => {
    let isValid = true;
    let errormessages = stepFormErrors;
    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      timeZone,
      companyId,
      clients,
      employeerole,
      group,
      acuityId,
    } = stepFormValues;


    // validate step
    switch (displayStep) {
      case 1:
        if (
          typeof firstName === "undefined" ||
          firstName === undefined ||
          firstName === ""
        ) {
          isValid = false;
          errormessages = {
            ...errormessages,
            firstName: "First Name is Required",
          };
        } else {
          errormessages = { ...errormessages, firstName: "" };
        }
        if (typeof lastName === "undefined" || lastName === "") {
          isValid = false;
          errormessages = {
            ...errormessages,
            lastName: "Last Name is Required",
          };
        } else {
          errormessages = { ...errormessages, lastName: "" };
        }

        if (typeof phoneNumber === "undefined" || phoneNumber === "") {
          isValid = false;
          errormessages = {
            ...errormessages,
            phoneNumber: "Mobile is Required",
          };
        } else if (!validator.isMobilePhone(phoneNumber, ["en-US", "en-IN"])) {
          isValid = false;
          errormessages = {
            ...errormessages,
            phoneNumber: "Invalid Mobile Number",
          };
        } else {
          errormessages = { ...errormessages, phoneNumber: "" };
        }

        if (typeof email === "undefined" || email === "") {
          isValid = false;
          errormessages = { ...errormessages, email: "Email Required" };
        } else if (!validator.isEmail(email)) {
          isValid = false;
          errormessages = { ...errormessages, email: "Invalid Email" };
        } else {
          errormessages = { ...errormessages, email: "" };
        }

        if (isValid) {
          let isunique = await checkUniqUserValidation();
          if (isunique !== true && isunique !== "") {
            isValid = false;
            errormessages = { ...errormessages, ...isunique };
          }
        }

        if (auth.userProfile.role === "superUser") {
          if (typeof companyId == "undefined" || companyId === "") {
            isValid = false;
            errormessages = {
              ...errormessages,
              companyId: "Company is Required",
            };
          } else {
            errormessages = { ...errormessages, timeZone: "" };
          }
        }

        if (typeof timeZone === "undefined" || timeZone === "") {
          isValid = false;
          errormessages = {
            ...errormessages,
            timeZone: "TimeZone is Required",
          };
        } else {
          errormessages = { ...errormessages, timeZone: "" };
        }

        if (isValid) {
          if (auth?.newEmpId || employeeId) {
            await runupdateEmployee();
          } else {
            await registerEmployee();
          }
        }

        break;
      case 2:
        if (typeof employeerole === "undefined" || employeerole === "") {
          isValid = false;
          errormessages = {
            ...errormessages,
            employeerole: "Role is Required",
          };
        } else {
          errormessages = { ...errormessages, employeerole: "" };

          // if (employeerole !== "Client Team") {
            await runupdateEmployee();
          // } else {
          //   setDisplayStep(3);
          // }
        }
        break;

      // case 3:
      //   if (
      //     employeerole === "Client Team" &&
      //     (typeof group === "undefined" || group === "" || group.length === 0)
      //   ) {
      //     await confirm(
      //       "This employee is not being assigned to any groups. Do you wish to proceed?"
      //     ).then(
      //       async () => {
      //         isValid = true;
      //         await runupdateEmployee();
      //       },
      //       () => {
      //         isValid = false;
      //       }
      //     );
      //   } else {
      //     await runupdateEmployee();
      //   }
      //   break;

      // case 4:
      //   if (
      //     typeof clients === "undefined" ||
      //     clients === "" ||
      //     clients.length === 0
      //   ) {
      //     if (employeerole === "Admin" || employeerole === "Guest") {
      //       isValid = true;
      //       await runupdateEmployee({ finalStep: true });
      //     } else {
      //       try {
      //         await confirm(
      //           "This employee is not being assigned to a client. Do you wish to proceed?"
      //         );
      //         isValid = true;
      //         await runupdateEmployee({ finalStep: true });
      //       } catch {
      //         isValid = false;
      //       }
      //     }
      //   } else {
      //     await runupdateEmployee({ finalStep: true });
      //   }
      //   break;

      // case 4:
      //   if (
      //     employeerole === "Client Team" &&
      //     settingsData?.[0]?.schedulingSystem !== "proteams" &&
      //     (typeof acuityId === "undefined" || acuityId === "")
      //   ) {
      //     isValid = false;
      //     errormessages = {
      //       ...errormessages,
      //       acuityId: "Acuity Id is Required",
      //     };
      //   } else {
      //     errormessages = { ...errormessages, acuityId: "" };
      //     await runupdateEmployee({ finalStep: true });
      //   }
      //   break;
      default:
        isValid = true;
        break;
    }
    setStepFormError(errormessages);
    // if (isValid) {
    //   goNext();
    // }
  };

  // const renderStepItem = (stepItem, index) => {
  //   const stepId = stepItem.id;
  //   const isEdit = typeof employeeId !== "undefined" && employeeId !== "";
  //   let stepClasses = "step step" + stepId + " ";
  //   stepClasses += currentStep > stepId ? "complated" : "";
  //   stepClasses += currentStep === stepId ? "activeStep" : "";
  //   return (
  //     <div key={`stepdiv${stepId}`} className={`${stepClasses}`}>
  //       <h4
  //         className="stepTitle"
  //         onClick={() => currentStep > stepId && setCurrentStep(stepId)}
  //       >
  //         {stepItem.title} <span className="right">{stepItem.subTitle}</span>
  //       </h4>
  //       <div className="stepContent">
  //         <div className="stepSection">
  //           {getStepContent(stepId)}
  //           {stepFormErrors?.finalerror &&
  //             stepFormErrors?.finalerror !== "" && (
  //               <span className="small error color-danger">
  //                 {stepFormErrors?.finalerror}
  //               </span>
  //             )}
  //           {companyEmployee && (
  //             <span className="color-danger">
  //               You have reached the maximum user limit. To add more users,
  //               please upgrade your plan.
  //             </span>
  //           )}
  //           <div className="buttonsWrap">
  //             <Button
  //               type="button"
  //               color={"primary"}
  //               variant={"contained"}
  //               className="flatbutton themeButton "
  //               onClick={() => validateAndGoNext()}
  //               disabled={
  //                 companyEmployee || finalLoading === true ? true : false
  //               }
  //             >
  //               {finalLoading === true
  //                 ? "Loading..."
  //                 : stepItem?.NextButtonText
  //                 ? stepItem?.NextButtonText
  //                 : "Next"}
  //             </Button>
  //             <DialogComponent
  //               buttonWrapClassName={"d-inline"}
  //               buttonClassName={"flatbutton"}
  //               buttonProps={{
  //                 size: "medium",
  //                 variant: "contained",
  //                 disabled: finalLoading === true ? true : false,
  //               }}
  //               buttonLabel={
  //                 stepItem?.CancelButtonText
  //                   ? stepItem?.CancelButtonText
  //                   : "Cancel"
  //               }
  //               ModalTitle={"Are you sure you want to cancel this entry?"}
  //               ModalContent={
  //                 <ConfirmCancel isEdit={isEdit} onCancelAll={onCancelAll} />
  //               }
  //             />
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  const onDeleteEmployee = async () => {
    await confirm(
      "Are you Sure you want to permanent Remove this employee?"
    ).then(
      () => {
        rundeleteEmployee();
      },
      () => {
        console.log("cancel!");
      }
    );
  };
  const onResetPassword = async () => {
    await confirm(
      "Are you Sure you want to Send Reset Password Link to this employee?"
    ).then(
      () => {
        ResetPasswordLink();
      },
      () => {
        console.log("cancel!");
      }
    );
  };
  const onResendinvitation = async () => {
    await confirm(
      "Are you Sure you want to Resend invitation to this employee?"
    ).then(
      () => {
        ResendinvitaLink();
      },
      () => {
        console.log("cancel!");
      }
    );
  };

  return (
    <>
      <Container>
        <PageTitle
          pageTitle={
            typeof employeeId !== "undefined" && employeeId !== ""
              ? "Edit Employee"
              : "Create Employee"
          }
          showBreadcrumb={[
            { label: "Home", to: "/" },
            { label: "Employees", to: "/peoples/manageEmp" },
          ]}
        />
        <div className={isMobile ? "pv-20" : "p-24"}>
          <div
            style={{ maxWidth: "900px", margin: "0px auto" }}
            className="mb-15"
          >
            {!employeeId && (
              <div className={isMobile ? "mv-10 mh-10" : ""}>
                <h1 className="text-xl md:text-2xl font-bold tracking-tight dark:text-white">
                  {displayStep === 1
                    ? "Create Profile"
                    : displayStep === 2
                    ? "Select Role"
                    : "Assign Clients"}
                </h1>
              </div>
            )}
            {typeof employeeId !== "undefined" && employeeId !== "" && (
              <div
                className={
                  isMobile
                    ? "d-flex flex-direction-column"
                    : "d-flex flex-center flex-space-between"
                }
              >
                <div className={isMobile ? "mv-10 mh-10" : ""}>
                  <h1 className="text-xl md:text-2xl font-bold tracking-tight dark:text-white">
                    {stepFormValues?.firstName} {" "} {stepFormValues?.lastName}
                  </h1>
                </div>
                <div className={isMobile ? "d-flex flex-direction-column" : ""}>
                  <Button
                    variant="outlined"
                    className={isMobile ? "mv-10 mh-10" : "mr-12"}
                    style={{
                      backgroundColor: "#FEF2F2",
                      color: "#DC2626",
                      border: "1px solid rgba(254, 202, 202, 1)",
                      padding: "8px 16px",
                    }}
                    onClick={onDeleteEmployee}
                  >
                    <Trash2 className="h-4 w-4 mr-8" />
                    Delete User
                  </Button>
                  <Button
                    variant="outlined"
                    className={isMobile ? "mv-10  mh-10" : "mr-12"}
                    style={{
                      backgroundColor: "#FEF2F2",
                      color: "#DC2626",
                      border: "1px solid rgba(254, 202, 202, 1)",
                      padding: "8px 16px",
                    }}
                    onClick={onResetPassword}
                  >
                    <KeyRound className="w-4 h-4 mr-8" />
                    Reset password
                  </Button>
                  <Button
                    variant="outlined"
                    className={isMobile ? "mv-10  mh-10" : "mr-12"}
                    style={{
                      backgroundColor: "#FEF2F2",
                      color: "#DC2626",
                      border: "1px solid rgba(254, 202, 202, 1)",
                      padding: "8px 16px",
                    }}
                    onClick={onResendinvitation}
                  >
                    <RotateCcw className="h-4 w-4 mr-8" />
                    Resend Invitation
                  </Button>
                </div>
              </div>
            )}
          </div>

          <div className={styles.tabs}>
            <div className={styles.tabBarWrapper}>
              <div className={styles.tabsList}>
                <Button
                  className={`${styles.tabTrigger} ${
                    displayStep === 1 ? styles.activeTab : styles.normalTab
                  }`}
                  onClick={() => setDisplayStep(1)}
                >
                  <span
                    className={`${styles.desktopsideOnly} ${
                      displayStep === 1
                        ? styles.activeTabText
                        : styles.normalTabText
                    }`}
                  >
                    1. Profile
                  </span>
                </Button>

                <Button
                  className={`${styles.tabTrigger} ${
                    displayStep === 2 ? styles.activeTab : styles.normalTab
                  }`}
                  onClick={() => setDisplayStep(2)}
                  disabled={
                    !stepFormValues?.firstName &&
                    !stepFormValues?.lastName &&
                    !stepFormValues?.email &&
                    !stepFormValues?.phoneNumber &&
                    !stepFormValues?.timeZone
                  }
                >
                  <span
                    className={`${styles.desktopsideOnly} ${
                      displayStep === 2
                        ? styles.activeTabText
                        : styles.normalTabText
                    }`}
                  >
                    2. Role
                  </span>
                </Button>
                {/* {stepFormValues?.employeerole === "Client Team" && (
                  <>
                    <Button
                      className={`${styles.tabTrigger} ${
                        displayStep === 3 ? styles.activeTab : styles.normalTab
                      }`}
                      onClick={() => setDisplayStep(3)}
                      disabled={!stepFormValues?.employeerole}
                    >
                      <span
                        className={`${styles.desktopsideOnly} ${
                          displayStep === 3
                            ? styles.activeTabText
                            : styles.normalTabText
                        }`}
                      >
                        3. Assign Groups
                      </span>
                    </Button>

                    <Button
                      className={`${styles.tabTrigger} ${
                        displayStep === 4 ? styles.activeTab : styles.normalTab
                      }`}
                      onClick={() => setDisplayStep(4)}
                      disabled={!stepFormValues?.employeerole}
                    >
                      <span
                        className={`${styles.desktopsideOnly} ${
                          displayStep === 4
                            ? styles.activeTabText
                            : styles.normalTabText
                        }`}
                      >
                        4. Assign Clients
                      </span>
                    </Button>
                  </>
                )} */}
              </div>
            </div>
            <div className={`${styles.tabContent}`}>
              {displayStep === 1 && (
                <div>
                  <StepProfile
                    handleInputChange={handleInputChange}
                    handleSingleSelectChange={handleSingleSelectChange}
                    validateAndGoNext={validateAndGoNext}
                    companyEmployee={companyEmployee}
                    onCancelAll={onCancelAll}
                    finalLoading={finalLoading}
                    isEdit={isEdit}
                    stepFormValues={stepFormValues}
                    stepFormErrors={stepFormErrors}
                    editData={editData}
                  />
                </div>
              )}
              {displayStep === 2 && (
                <div>
                  <AssignGroup
                    handleInputChange={handleInputChange}
                    validateAndGoNext={validateAndGoNext}
                    companyEmployee={companyEmployee}
                    onCancelAll={onCancelAll}
                    finalLoading={finalLoading}
                    isEdit={isEdit}
                    stepFormValues={stepFormValues}
                    stepFormErrors={stepFormErrors}
                  />
                </div>
              )}
              {/* {displayStep === 3 &&
                stepFormValues?.employeerole === "Client Team" && (
                  <div>
                    <AssignEmpGroup
                      handleInputChange={handleInputChange}
                      validateAndGoNext={validateAndGoNext}
                      companyEmployee={companyEmployee}
                      onCancelAll={onCancelAll}
                      finalLoading={finalLoading}
                      isEdit={isEdit}
                      stepFormValues={stepFormValues}
                      stepFormErrors={stepFormErrors}
                      allgroups={allgroups}
                    />
                  </div>
                )}
              {displayStep === 4 &&
                stepFormValues?.employeerole === "Client Team" && (
                  <div>
                    <ClientTeam
                      handleInputChange={handleInputChange}
                      validateAndGoNext={validateAndGoNext}
                      companyEmployee={companyEmployee}
                      onCancelAll={onCancelAll}
                      finalLoading={finalLoading}
                      isEdit={isEdit}
                      stepFormValues={stepFormValues}
                      stepFormErrors={stepFormErrors}
                      clientsList={clientsList}
                    />
                  </div>
                )} */}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default CreateEmployee;
